import React, { useState } from "react";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";

import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";

import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { Box, createTheme, ThemeProvider } from "@mui/material";
import { Padding } from "@mui/icons-material";

const MothYearPicker = ({ value, setValue }) => {

  const customTheme = createTheme({
    components: {
      MuiTextField: {
        styleOverrides: {
          root: {
            "& .MuiInputBase-input": {
              fontSize: "14px", // Font size for the input field
            },
          },
        },
      },
      MuiPickersDay: {
        styleOverrides: {
          root: {
            fontSize: "12px", // Font size for the calendar days
          },
        },
      },
      MuiTypography: {
        styleOverrides: {
          root: {
            fontSize: "12px", // Font size for typography inside the Date Picker
          },
        },
      },
      // MuiPopover: {
      //   styleOverrides: {
      //     paper: {
      //       fontSize: "2px", // Font size for the dropdown calendar popover
      //       padding: "8px",   // Add padding around the calendar dropdown
      //     },
      //   },
      // },
    },
  });

  return (
    <ThemeProvider theme={customTheme}>
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <Box className="summary-month-year">
      <DatePicker
        label={"month & year"}
        views={["month", "year"]}
        onChange={(newValue) => setValue(newValue)}
        defaultValue={value}
      />
      </Box>
    </LocalizationProvider>
    </ThemeProvider>
  );
};

export default MothYearPicker;
